import PageHome from '@/PageHome.vue';
import NotFound from '@/layout/components/NotFound.vue';
import PageGames from '@/games/PageGames.vue';
import PageGame from '@/games/PageGame.vue';
import PagePhrases from '@/PagePhrases.vue';
import router from '@/router';
import store from '@/store';

router.addRoutes([
  /*
   * MAIN ROUTES
   */
  {
    path: '/',
    name: 'home',
    component: PageHome,
    meta: {
      requiresAuth: false,
      label: 'Home',
    },
  },
  {
    path: '/games',
    name: 'games',
    component: PageGames,
    meta: {
      requiresAuth: true,
      label: 'Spiele',
    },
  },
  {
    path: '/games/:game',
    name: 'game',
    component: PageGame,
    meta: {
      label(route) {
        const label = 'Mein Spiel';
        if (
          store.state.games.list == null
          || store.state.games.list[route.params.game] == null
        ) {
          return label;
        }
        return store.state.games.list[route.params.game].name;
      },
    },
    // check if user is in the game
    beforeEnter: async (to, from, next) => {
      await store.dispatch('games/subscribe');
      if (
        store.state.games.list == null
        || store.state.games.list[to.params.game] == null
      ) {
        return next({ name: 'games' });
      }
      const game = store.state.games.list[to.params.game];
      if (
        game.players.length >= game.requiredPlayers
        && !game.players.includes(store.state.auth.uid)
      ) {
        return next({ name: 'games' });
      }
      return next();
    },
  },
  {
    path: '/phrases',
    name: 'phrases',
    component: PagePhrases,
    meta: {
      requiresAuth: false,
      label: 'Text pflegen',
    },
  },
  /*
   * 404
   */
  {
    path: '*',
    name: '404',
    component: NotFound,
    meta: {
      requiresAuth: false,
    },
  },
]);

/**
 * init auth route guards
 */
router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    return next();
  }
  if (store.state.auth.uid == null) {
    return next({ name: 'home' });
  }
  return next();
});
